<template>
    <!-- 试听视频页面 --需要对接数据-->
    <section class="container">
        <div class="wrapper videoM">
            <div class="title">
                课程试听 ：    {{videotitle}}
            </div>
            <div class="flex-row inner-wrapper">
                <div class="col-100">
                    <video-player  class="video-player vjs-custom-skin"
                                   ref="videoPlayer"
                                   :playsinline="true"
                                   :options="playerOptions"
                                   @play="onPlayerPlay($event)"
                                   @pause="onPlayerPause($event)"
                                   @timeupdate="onPlayerTimeupdate($event)"
                                   @statechanged="playerStateChanged($event)"
                    >
                    </video-player>
                </div>
            </div>
        </div>
		 <Button class="course-btn" type="primary" size="medium " @click="goback" data-id="">
		    返回课程列表
		</Button>
        <Footer></Footer>
    </section>
</template>

<script>
    import Footer from './components/Footer'
    import { videoPlayer } from 'vue-video-player'
    export default {
        name: "AuditionVideo",
        data(){
            return {
                videotitle:'',
                playerOptions: {},
                last: 0
            }
        },
        mounted(){
            //判断网页是否激活状态
            var hiddenProperty = 'hidden' in document ? 'hidden' :
                'webkitHidden' in document ? 'webkitHidden' :
                    'mozHidden' in document ? 'mozHidden' :
                        null;
            var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
            var onVisibilityChange = function(){
                if (!document[hiddenProperty]) {
                    // console.log('页面非激活');
                }else{
                    // console.log('页面激活')
                }
            };
            document.addEventListener(visibilityChangeEvent, onVisibilityChange);

            var that = this;
            var url = this.$store.state.auditionUrl;
            that.videotitle = this.$store.state.auditionTitle;
            if(url !=''){
              that.playerOptions = that.setVideoOption(url);
            }else {
                that.$Message.error('试听视频播放有误，请重新尝试')
                that.$router.push('/');
            }

        },
        components: {
            videoPlayer,
            Footer
        },
        methods: {
            goback () {
              this.$router.go(-1)
            },
            setVideoOption(videoUrl){   //视频参数配置
                return {
                  playbackRates: [0.75, 1.0, 1.25, 1.5], //播放速度
                  autoplay: false, //如果true,浏览器准备好时开始回放。
                  muted: false, // 默认情况下将会消除任何音频。
                  loop: false, // 导致视频一结束就重新开始。
                  preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                  language: 'zh-CN',
                  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                  fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                  sources: [{
                    type: "video/mp4",
                    src: videoUrl //你的视频地址（必填）
                  }],
                  poster: "poster.jpg", //你的封面地址
                  width: document.documentElement.clientWidth,
                  notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                  controlBar: {
                    // timeDivider: true,
                    // durationDisplay: true,
                    // remainingTimeDisplay: false,
                    // fullscreenToggle: true  //全屏按钮,
                    // progressControl: true,
                  },
                  // controlBar: false
                };
            },
            onPlayerPlay(player) {
                // alert("play");
            },
            onPlayerPause(player){
                // alert("pause");
            },
            onPlayerTimeupdate(player){
                var current = player.currentTime();
                if(current - this.last > 2) {
                    player.currentTime(this.last);
                } else {
                    this.last = current;
                }
            },
            playerStateChanged(playerCurrentState) {
                // console.log('player current update state', playerCurrentState)
            }
        },
        computed: {
            player() {
                return this.$refs.videoPlayer.player
            }
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-bottom: 50px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 70px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .inner-wrapper{
        margin-top: 20px;
        /*height: 472px;*/
    }
    .inner-wrapper .col-30{
        padding: 0 10px 10px;
    }
    .title2{
        color: #333;
        font-size: 21px;
        font-weight: bold;
        padding-left: 8px;
    }
    .concern{
        height: 441px;
        overflow-y: auto;
        font-size: 16px;
    }
    .videoList{
        padding: 12px 0;
        border-bottom: solid 1px #ccc;
    }
    .point{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #1a87cc;
        margin: auto;
        position: relative;
        top: 7px;
    }
</style>

<style>
    .videoM button{
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/views/AuditionVideo.vue